import React, { useEffect } from "react";
import AddIcon from "@mui/icons-material/Add";
import { useResetInputs } from "src/Contexts";
import { useAuthContext } from "src/Contexts/AuthContext/authContext";
import { ModalCore } from "src/Pages/components";
import { ButtonCore } from "src/Pages/components/ButtonCore/ButtonCore";
import { valuesPermissions } from "src/shared/Utils/ValuesPermissions";

import { FormAdministradora } from "./FormularioAdministradora";
import { UseFeaturesFormAdministradora } from "./Hooks/UseFeaturesFormulario";

interface IModalAdministradora {
  openModal: boolean;
  setOpenModal: React.Dispatch<React.SetStateAction<boolean>>;
}

export const ModalAdministradora = ({
  openModal,
  setOpenModal,
}: IModalAdministradora) => {
  const { userPerfil } = useAuthContext();
  const { resetInputs } = useResetInputs();

  const { handleSubmit, loading: loadingSubmit } = UseFeaturesFormAdministradora({
    setOpenModal,
  });

  useEffect(() => {
    if (!openModal) resetInputs();
  }, [openModal]);

  return (
    <>
      <ButtonCore
        disabled={
          userPerfil?.type_user === "USER" &&
          !userPerfil?.permissions.permissions.includes(
            valuesPermissions.ADMINISTRADORA.CREATE.id
          )
        }
        startIcon={<AddIcon />}
        title="Criar Administradora"
        onClick={() => setOpenModal(true)}
      />

      <ModalCore
        loadingSubmit={loadingSubmit}
        open={openModal}
        setOpen={setOpenModal}
        sxStyle={{ width: "500px" }}
        title="Administradora"
        titleSubmit="Salvar"
        onChange={handleSubmit}
      >
        <FormAdministradora />
      </ModalCore>
    </>
  );
};
